import "./system/constants.js";
import { compileInputSystem as e } from "./system/definition.js";
import "./key/constants.js";
import { useRegisterScope as i, useRegisterAction as o } from "./provider/index.js";
function u(t) {
  return {
    inputSystem: e(t),
    useRegisterAction: o,
    useRegisterScope: i
  };
}
export {
  u as defineInputSystem
};
